import { View } from "react-native";
import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import native from "src/constants/native";
import { useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import { paddingLarge } from "src/styles/spacing";
import GatheringAppleMusicAddonEdit from "./components/GatheringAppleMusicAddonEdit";
import GatheringTextAddonEdit from "./components/GatheringTextAddonEdit";
import { useGatheringAddonEditModalDimensions } from "./GatheringAddonEditModalSkeleton";

const GatheringAddonEditModal = () => {
	const style = useGatheringAddonEditModalDimensions();
	const {
		props: { variant },
	} = useInsideModal<GatheringModal["GatheringAddonEditModal"]>();

	return (
		<View
			style={[
				style,
				{
					flexDirection: "column",
					paddingTop: native ? 0 : paddingLarge,
				},
			]}
		>
			{variant === AddonVariant.AppleMusic ? (
				<GatheringAppleMusicAddonEdit />
			) : (
				<GatheringTextAddonEdit />
			)}
		</View>
	);
};
export default GatheringAddonEditModal;
